document.querySelector('.js-toggle-navigation').addEventListener('click', () => {
  document.documentElement.classList.toggle('navigation-opened');

  if (document.documentElement.classList.contains('navigation-opened')) {
    document.querySelectorAll('body, html').forEach((element) => {
      element.addEventListener('touchstart touchmove', (e) => e.preventDefault());
    });
  }
});
